import { apiClient } from "./client";
import type { TournamentDetail, TournamentResultRequest } from "../types/swagger";
import { mockTournamentDetails } from "../mocks/fixtures/tournaments";

export interface TournamentUpdateRequest {
  mode: "RECREATE" | "KEEP";
}

export type { TournamentDetail, TournamentResultRequest };

const USE_MOCK = process.env.REACT_APP_USE_MOCK === "true";

let mockTournamentStore: TournamentDetail[] = mockTournamentDetails.map((detail) => ({
  ...detail,
}));

// UI表示用の対戦ペア
export interface MatchPair {
  round: number;
  blockNumber: number;
  p1TournamentId?: string;
  p2TournamentId?: string;
  p1Name: string;
  p2Name: string;
  p1Wins: number | null;
  p2Wins: number | null;
}

export const tournamentsApi = {
  /** トーナメント取得 GET /event/{event_id}/tournament */
  getTournament: async (eventId: number | string): Promise<TournamentDetail[]> => {
    if (USE_MOCK) {
      return mockTournamentStore.filter(
        (detail) => String(detail.event_id) === String(eventId),
      );
    }
    const { data } = await apiClient.get<TournamentDetail[]>(`/event/${eventId}/tournament`);
    return data;
  },

  /** トーナメント更新 PUT /event/{event_id}/tournament */
  updateTournament: async (
    eventId: number | string,
    body: TournamentUpdateRequest
  ): Promise<void> => {
    if (USE_MOCK) {
      if (body.mode === "RECREATE") {
        mockTournamentStore = mockTournamentStore.filter(
          (detail) => String(detail.event_id) !== String(eventId),
        );
      }
      return;
    }
    await apiClient.put(`/event/${eventId}/tournament`, body);
  },

  /** 試合結果登録 POST /event/{event_id}/tournament/result */
  registerTournamentResult: async (
    eventId: number | string,
    body: TournamentResultRequest
  ): Promise<void> => {
    if (USE_MOCK) {
      void eventId;
      void body;
      return;
    }
    await apiClient.post(`/event/${eventId}/tournament/result`, body);
  },
};
